module.exports = __webpack_public_path__ + "img/icon_卡片_赛事认证@2x.f8dbd6e5.png";